/**
 * Ops hub tab wrappers.
 * All 3 tabs use their V2 mockup layouts.
 */
import InterventionsTabV2 from "@/pages/ops/InterventionsTabV2";
import PlansActionTabV2 from "@/pages/ops/PlansActionTabV2";
import AlertesTabV2 from "@/pages/ops/AlertesTabV2";

export function InterventionsTab() { return <InterventionsTabV2 />; }
export function PlansActionTab() { return <PlansActionTabV2 />; }
export function AlertesTab() { return <AlertesTabV2 />; }
